<template>
    <div class="winList">
  <div
    class="list"
    :style="{
        height:'120px',
      transform: `translateY(-${offset}px)`
    }"
  >
    <div class="item" v-for="(item, index) in list" :key="index" style="height: 40px;">
      <div style="margin: 4px;font-size: 12px;width: 50px;">{{ item.tag }}</div>
      <div style="margin: 4px;font-size: 12px;width: 36px;">{{ item.name }}</div>
      <div style="margin: 4px;font-size: 12px;">{{ item.desc }}</div>
      <div style="margin: 4px;font-size: 12px;width: 75px;">{{ item.note }}</div>
    </div>
  </div>
</div>
</template>
<script>
import utils from '../home/utils';
export default {
  data() {
    return {
      list: [],
      itemHeight: 40,
      offset: 0
    }
  },
  mounted() {
    for (let i = 0; i < 20; i++) {
        this.list.push(utils.generateNotice_lottery())
    }
    this.startScroll()
  },
  methods: {
    startScroll() {
      setInterval(() => {
        // 👉 向上滚动一条
        this.offset = this.itemHeight

        // 👉 动画结束后处理数据
        setTimeout(() => {
          // 删除第一条
          if(this.list.length>20){
            this.list.shift()
          }

          // 👉 追加新数据（关键）
          this.list.push(utils.generateNotice_lottery())

          // 👉 重置位移（防止越来越大）
          this.offset = 0
        }, 500) // 和CSS动画时间一致

      }, 3000)
    },
  }
}
</script>
<style lang="less" scoped>
.winList {
  overflow: hidden;
position: relative;
overflow: hidden;
margin: 0 50px;
border: 1px solid #ddd;
border-bottom-left-radius: 4px;
border-bottom-right-radius: 4px;
}

.list {
  transition: transform 0.5s;
}

.item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  justify-content: space-evenly;
  div {
    display: inline-block;
    text-align: left;
    overflow: hidden;
}
}
</style>